module.exports = __webpack_public_path__ + "static/media/blue-bang.bf8b974d.svg";